__turbopack_context__.v({
  "actions": "FollowButtonGDPRModal-module-scss-module__NoXMgq__actions",
  "content": "FollowButtonGDPRModal-module-scss-module__NoXMgq__content",
});
